import httpHelper from "../helpers/httpHelper";

const authenticateService = {
    async changePasswordByToken(data) {
        return await httpHelper.post("/v2/Authenticate/ChangePasswordByToken", data)
    }
}

export default authenticateService
